import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import type { FC } from 'react';

import { ResponsiveText } from '../ResponsiveText';

import translations from './.vocab';

import * as styles from './FilterFacetBadge.css';

export const FilterFacetBadge: FC<{
  count: number;
  isHighlighted: boolean;
  bleedY?: boolean;
}> = ({ count, isHighlighted, bleedY = false }) => {
  const { t } = useTranslations(translations);
  return (
    <Box
      className={{ [styles.countBadgePadding]: true, [styles.bleedY]: bleedY }}
      borderRadius="small"
      background={isHighlighted ? 'surface' : 'neutralLight'}
      aria-hidden
    >
      <ResponsiveText
        size={{
          mobile: 'small',
          tablet: 'xsmall',
        }}
        fallbackSize="xsmall"
        maxLines={1}
      >
        {t('count', {
          count,
        })}
      </ResponsiveText>
    </Box>
  );
};
